const UNIFY_ADMIN_SHELL_ROLES = new Set([
  'Unify Admin',
  'unify-admin',
]);

/** Unify Admin display shell. */
export function isUnifyAdminShellRole(role: string | undefined): boolean {
  return role != null && UNIFY_ADMIN_SHELL_ROLES.has(role);
}

/** Clinical settings is the Unify Admin role only. */
export function isClinicalSettingsVisible(role?: string, roleSlug?: string): boolean {
  if (roleSlug) return roleSlug === 'unify-admin';
  return role === 'Unify Admin' || role === 'unify-admin';
}

/** Staff `/dashboard/*` paths gated by role independently of RBAC. */
export function isStaffFeaturePathVisible(pathname: string, role?: string, roleSlug?: string): boolean {
  if (pathname.startsWith('/dashboard/settings/clinical')) {
    return isClinicalSettingsVisible(role, roleSlug);
  }
  if (
    pathname.startsWith('/dashboard/settings/sessions')
    || pathname.startsWith('/dashboard/settings/documentation')
  ) {
    return isUnifyAdminShellRole(role);
  }
  return true;
}
